import React from "react";
import TrackingWidgetContainer from "./containers/trackingWidgetContainer";
import { QueryClientProvider, QueryClient } from "react-query";
import { MbmProvider } from "@amzn/react-arb-tools";
import { getMbmOptions } from "./i18n/LocalizationHelpers";
import { DEFAULT_LOCALE } from "./i18n/constants";

const queryClient = new QueryClient();

const getLocale = (): string => {
  const el = document?.getElementById("Rttv-Widget-Locale") as HTMLInputElement;
  return el?.value || document?.documentElement?.lang || DEFAULT_LOCALE;
};

function App() {
  const locale = getLocale();

  return (
    <MbmProvider {...getMbmOptions(locale)}>
      <QueryClientProvider client={queryClient}>
        <TrackingWidgetContainer/>
      </QueryClientProvider>
    </MbmProvider>
  );
}

export default App;
